import { ListTree, TriangleAlert } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'

type PackedItemSkuCellProps = {
  sku: string
  notInSourceList?: boolean
  fromPartsCatalog?: boolean
}

export function PackedItemSkuCell({
  sku,
  notInSourceList = false,
  fromPartsCatalog = false,
}: PackedItemSkuCellProps) {
  const { t } = useTranslation('packagingSuppliers')

  return (
    <span className='flex min-w-0 items-center gap-1.5'>
      <span className='truncate'>{sku}</span>
      {fromPartsCatalog && (
        <Tooltip>
          <TooltipTrigger asChild>
            <button
              type='button'
              className='inline-flex shrink-0 text-blue-600 dark:text-blue-500'
              aria-label={t('packedItems.fromPartsCatalogTooltip')}
            >
              <ListTree className='size-3.5' aria-hidden />
            </button>
          </TooltipTrigger>
          <TooltipContent side='top' className='max-w-xs'>
            {t('packedItems.fromPartsCatalogTooltip')}
          </TooltipContent>
        </Tooltip>
      )}
      {notInSourceList && (
        <Tooltip>
          <TooltipTrigger asChild>
            <button
              type='button'
              className='inline-flex shrink-0 text-amber-600 dark:text-amber-500'
              aria-label={t('packedItems.notInSourceListTooltip')}
            >
              <TriangleAlert className='size-3.5' aria-hidden />
            </button>
          </TooltipTrigger>
          <TooltipContent side='top' className='max-w-xs'>
            {t('packedItems.notInSourceListTooltip')}
          </TooltipContent>
        </Tooltip>
      )}
    </span>
  )
}
